

type ProductItemProps = {
    item: any;
    promoType: 'best' | 'lite' | 'top' | null;
    bonusRatio?: number;
    onClick: (productId: string) => void;
    useTheme?: boolean;
}

const ProductItem: React.FC<ProductItemProps> = ({ item, promoType, bonusRatio, onClick, useTheme = true }) => {
    const details = PageShop.getProductDetails(item.productId);
  
    const getBadgeText = () => {

      if (promoType === 'best') {
        return 'Best';
      }

      if (promoType === 'top') {
        return 'Top Benefit';
      }
      
      if (promoType === 'lite') {
        return 'Lite';
      }

      return 'Normal';
    };
    const getBadgeStyle = (): React.CSSProperties | undefined => {
      if (promoType === 'top') {
        return {
          background: 'linear-gradient(90deg, #0CD7C4 0%, #8656FF 50%, #FF81F1 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          color: 'transparent',
          backgroundColor: '#4A4F55',
        };
      }
  
      return { color: '#FFFFFF' };
    };

    const getBadgeContainerStyle = (): React.CSSProperties | undefined => {
        if(promoType === 'best') {
            return {
                backgroundColor: 'var(--bcs-semantic-badge-bg-red)',
                borderRadius: 'var(--radius-xs)'
            };
        }

        if(promoType) {
            return { 
                backgroundColor: '#4A4F55',
                borderRadius: 'var(--radius-xs)'
            };
        }
    };
  
    return (
      <div className="flex h-full w-full flex-col overflow-hidden rounded-lg shadow-03" onClick={() => onClick(item.productId)}>
        <div
          className="h-[80px] w-full flex-shrink-0 text-center"
          style={{
            backgroundColor: '#FFF0BC',
            backgroundImage: promoType ? 'url(/imgweb/promo/effect_coin_bg.svg)' : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <img className="h-full object-contain" alt="" src={PageShop.getCoinURL(item.productId)} />
        </div>
        <div className="flex w-full flex-grow flex-col gap-1 p-2" style={{ backgroundColor: useTheme ? 'var(--bcs-semantic-base-bg-default)' : '#35393E', color: useTheme ? 'var(--bcs-semantic-dialog-txt-default)' : '#FFFFFF' }}>
          <div className="w-fit px-2 py-1 text-[12px] font-bold" style={{ visibility: promoType ? 'visible' : 'hidden', ...getBadgeContainerStyle() }}>
            <span style={getBadgeStyle()}>{getBadgeText()}</span>
          </div>
          <div className="typography-headline-sm">
            {details.coinAmount} Coins {bonusRatio && bonusRatio > 0 ? <span className="text-[#FF6566]">+{details.coinAmount * (bonusRatio / 100)}</span> : null}
          </div>
          <div className="typography-caption-body">{details.price}</div>
        </div>
      </div>
    );
  };

  export default ProductItem;